(() => {
  const track = (eventName, payload = {}) => {
    const data = { event: eventName, ...payload };
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(data);
    document.dispatchEvent(new CustomEvent('lovetenet:analytics', { detail: data }));
  };

  const recommendationFor = ({ area, wearable }) => {
    if (area === 'neck_decollete' || area === 'body_targeted') return 'A081';
    if (area === 'face') return wearable === 'yes' ? 'A097' : wearable === 'no' ? 'A083' : null;
    return null;
  };

  const reasonsFor = ({ area, wearable, priority }, recommendation) => {
    const reasons = [];
    if (area === 'face') reasons.push('You selected facial use.');
    if (area === 'neck_decollete') reasons.push('You selected the neck or décolleté.');
    if (area === 'body_targeted') reasons.push('You selected a targeted body area.');
    if (wearable === 'yes') reasons.push('You prefer a wearable, hands-free format.');
    if (wearable === 'no') reasons.push('You prefer a non-wearable panel.');
    const priorityReasons = {
      hands_free: 'Hands-free convenience matters most to you.',
      multi_wavelength: 'You value a multi-wavelength facial routine.',
      non_wearable: 'Non-wearable comfort matters most to you.',
      flexible_positioning: 'You value flexible positioning.'
    };
    if (priorityReasons[priority]) reasons.push(priorityReasons[priority]);
    if (recommendation === 'A081') reasons.push('A directional panel aligns with the area you selected.');
    return reasons.slice(0, 4);
  };

  const setConditionalState = (root, form) => {
    const area = new FormData(form).get('area');
    const wearable = new FormData(form).get('wearable');
    const faceQuestion = root.querySelector('[data-face-question]');
    const priorityQuestion = root.querySelector('[data-priority-question]');
    const submit = root.querySelector('[data-find-device-submit]');
    const isFace = area === 'face';
    faceQuestion.hidden = !isFace;
    priorityQuestion.hidden = !(isFace && wearable);
    faceQuestion.querySelectorAll('input').forEach((input) => { input.disabled = !isFace; });
    priorityQuestion.querySelectorAll('input').forEach((input) => { input.disabled = !(isFace && wearable); });
    submit.hidden = !area || (isFace && !wearable);
  };

  const init = (root) => {
    if (!root || root.dataset.findDeviceReady === 'true') return;
    root.dataset.findDeviceReady = 'true';
    const form = root.querySelector('[data-find-device-form]');
    const result = root.querySelector('[data-find-device-result]');
    if (!form || !result) return;
    let started = false;

    form.addEventListener('change', () => {
      if (!started) {
        started = true;
        track('find_device_quiz_start', { page_path: location.pathname });
      }
      setConditionalState(root, form);
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const fd = new FormData(form);
      const answers = {
        area: fd.get('area') || '',
        wearable: fd.get('wearable') || '',
        priority: fd.get('priority') || ''
      };
      const recommendation = recommendationFor(answers);
      if (!recommendation) return;
      root.querySelectorAll('[data-recommendation]').forEach((node) => {
        node.hidden = node.dataset.recommendation !== recommendation;
      });
      const active = root.querySelector('[data-recommendation="' + recommendation + '"]');
      const reasonList = active?.querySelector('[data-reasons]');
      if (reasonList) {
        reasonList.replaceChildren(...reasonsFor(answers, recommendation).map((reason) => {
          const li = document.createElement('li');
          li.textContent = reason;
          return li;
        }));
      }
      result.hidden = false;
      result.setAttribute('tabindex', '-1');
      result.focus({ preventScroll: true });
      result.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
      track('find_device_quiz_complete', { recommendation, area: answers.area, wearable_preference: answers.wearable, priority: answers.priority });
      track('find_device_recommendation', { product: recommendation });
    });

    root.querySelectorAll('[data-product-cta]').forEach((link) => {
      link.addEventListener('click', () => track('find_device_product_click', {
        product: link.dataset.product || '',
        source_section: link.dataset.sourceSection || ''
      }));
    });
    root.querySelectorAll('[data-compare-cta]').forEach((link) => {
      link.addEventListener('click', () => track('find_device_compare_click', { source: link.dataset.source || '' }));
    });
    root.querySelectorAll('[data-routine-cta]').forEach((link) => {
      link.addEventListener('click', () => track('find_device_routine_click', { product_type: link.dataset.productType || '' }));
    });

    root.querySelector('[data-find-device-reset]')?.addEventListener('click', () => {
      form.reset();
      result.hidden = true;
      root.querySelectorAll('[data-recommendation]').forEach((node) => { node.hidden = true; });
      setConditionalState(root, form);
      form.querySelector('input')?.focus();
    });
    setConditionalState(root, form);
  };

  window.LovetenetFindDevice = Object.freeze({ recommendationFor });
  document.querySelectorAll('[data-find-device-section]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.matches?.('[data-find-device-section]') ? event.target : event.target.querySelector?.('[data-find-device-section]'));
  });
})();
